import React from 'react';
import { Box, Button, Modal } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import strings from '../../resources/strings';
import { format } from 'date-fns';
import { getUserId } from '../../store/auth/selectors';
import { getLanguagesList } from '../../store/languages/selectors';
import { connect } from 'react-redux';
import { AppState } from '../../store/rootReducer';
import DatePickerInput from '../../components/DatePickerInput/DatePickerInput';

const KnowledgePageModal: React.FC<any> = ({
    actualEvent,
    setActualEvent,
    typeList,
    openModal,
    setSuccessMessage,
    setOpenModal,
    firebaseEventSend,
    firebaseEventsUpdate,
}) => {
    return (
        <Modal
            open={openModal}
            onClose={() => setOpenModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        margin: '3rem 0',
                        gap: 2,
                    }}
                >
                    <DatePickerInput
                        label={strings.newsAndEvents.dateFrom}
                        value={actualEvent.publishFrom ? format(actualEvent.publishFrom, 'yyyy-MM-dd') : null}
                        minDate={Date.now()}
                        name="publishFrom"
                        item={actualEvent}
                        setItem={setActualEvent}
                    ></DatePickerInput>
                    <DatePickerInput
                        label={strings.newsAndEvents.dateTo}
                        value={actualEvent.publishTo ? format(actualEvent.publishTo, 'yyyy-MM-dd') : null}
                        minDate={Date.now()}
                        name="publishTo"
                        item={actualEvent}
                        setItem={setActualEvent}
                    ></DatePickerInput>
                </Box>

                <Button
                    onClick={() => {
                        setActualEvent({
                            ...actualEvent,
                            publishFrom: actualEvent.publishFrom || new Date(),
                            publishTo: actualEvent.publishTo || new Date(),
                        });
                        if (firebaseEventSend) {
                            if (typeList.find((el: any) => el.id !== actualEvent.id)) {
                                firebaseEventSend(actualEvent);
                                setOpenModal(false);
                                setSuccessMessage(strings.newsAndEvents.successPublish);
                            } else {
                                if (actualEvent.id) {
                                    firebaseEventsUpdate(actualEvent.id, actualEvent);
                                }
                                setOpenModal(false);
                            }
                        } else {
                            firebaseEventsUpdate(strings.newsAndEvents.successPublish);
                            setOpenModal(false);
                        }
                    }}
                    startIcon={<SendIcon />}
                    variant="contained"
                    href="#contained-buttons"
                    sx={{ margin: 'auto' }}
                >
                    {strings.newsAndEvents.buttons.publish}
                </Button>
            </Box>
        </Modal>
    );
};

function mapStateToProps(state: AppState) {
    return {
        userId: getUserId(state),
        languages: getLanguagesList(state),
    };
}

export default connect(mapStateToProps)(KnowledgePageModal);
